import { render, staticRenderFns } from "./OnlineClip.vue?vue&type=template&id=61d0c16a&scoped=true&"
import script from "./OnlineClip.vue?vue&type=script&lang=js&"
export * from "./OnlineClip.vue?vue&type=script&lang=js&"
import style0 from "./OnlineClip.vue?vue&type=style&index=0&id=61d0c16a&lang=stylus&scoped=true&"
import style1 from "./OnlineClip.vue?vue&type=style&index=1&id=61d0c16a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0c16a",
  null
  
)

export default component.exports